// dynamically update the cart item when it's data is not ready yet
$(function(){
  var json = getValidUpdates();

  json.forEach((item) => {
    // get the cartitem element that contains this key
    var key = getKey(item);
    var $cartItem = $(`.cart__row[data-key="${key}"]`);
    // if the cartitem does not exist short
    if (!$cartItem || !$cartItem.length)
      return false;
    // for each shop you may need additional conditions to find various fields
    var $productImgAnchor = $cartItem.find('.cart__image'),
      $productImg = $cartItem.find('.cart__image img'),
      $itemAnchor = $cartItem.find('.grid__item .grid__item a.h5'),
      $productTitle = $cartItem.find('.grid__item .grid__item a.h5'),
      $qtyInput = $cartItem.find('.cart__quantity-selector'),
      $price = $cartItem.find('.grid__item .cart-product-price'),
      $priceOriginal = $cartItem.find('.grid__item .cart-product-price-original'),
      $pricePerUnit = $cartItem.find('.grid__item .cart-product-unit-price'),
      $editLink = $cartItem.find('.edit-link'),
      $orderTotal = $('.cart__subtotal .saw-cart-original-total');
    // make sure this cart item has empty values before replacing anything
    if ($.trim($productTitle.text()) !== '') {
      return;
    }
    // update anchor urls
    $productImgAnchor.add($itemAnchor).attr('href', item.addResponse.url);
    // update image
    if (item.addResponse.properties.front_image) {
      $productImg.before(`
      <div class="uploaded-image uploaded-image-container" style="padding-top: ${item.addResponse.properties._trim_overlay_aspect}%; background-image: url(${item.addResponse.properties.front_image.replace('https://cdn.filestackcontent.com/', 'https://process.filestackapi.com/output=f:jpg/resize=width:250/')})">
        <img src="${item.addResponse.properties._trim_overlay}">
      </div>
      `);
      $productImg.remove();
    } else {
      $productImg.attr('src', item.addResponse.image);
    }
    // update title and variant name
    $productTitle.text(item.addResponse.product_title);
    $editLink.attr('href', item.addResponse.url + $editLink.attr('href'))
    // find this item in the change response
    var itemInChangeResponse = item.changeResponse.items.find((val) => key === val.key)
    // set quantity
    $qtyInput.val(itemInChangeResponse.quantity).prop('disabled', true);
    // set line item price
    $price.text(formatPrice(itemInChangeResponse.final_line_price));
    $priceOriginal.text(formatPrice(itemInChangeResponse.original_line_price));
    $pricePerUnit.text(formatPrice(itemInChangeResponse.final_price));
    // set the order total price
    $orderTotal.text(formatPrice(item.changeResponse.total_price));
  });

  function getKey(item) {
    for (var i = 0, l = item.changeResponse.items.length; i < l; i++) {
      if (item.changeResponse.items[i].id === item.addResponse.id)
        return item.changeResponse.items[i].key;
    }

    return '';
  }

  function getValidUpdates() {
    // get the value inside of local storage
    var value = localStorage.getItem('cart-update-value');
    // if there is no value, short
    if (value === null)
      return [];
    // parse the value from local storage
    var json = JSON.parse(value);
    // make sure this is an array
    if (!Array.isArray(json))
      return [];

    var filteredJson = json.filter((value) => {
      // set the cutoff for 3 minutes
      var CUTOFF_MILISECONDS = 5 * 60 * 1000;
      // check direct format
      if (!('addResponse' in value) || !('changeResponse' in value) || !('time' in value))
        return false;
      // check when this storage was set and die if it has been too long
      if (!Number.isInteger(value.time) || Date.now() - value.time > CUTOFF_MILISECONDS)
        return false;
      // make sure a product key exists
      if (!('key' in value.addResponse))
        return false;

      return true;
    });

    if (filteredJson.length === 0) {
      localStorage.removeItem('');
      return [];
    }

    localStorage.setItem('cart-update-value', JSON.stringify(filteredJson));

    return filteredJson;
  }
  // turn an int into a formated price point
  function formatPrice(price) {
    var dollars = Math.floor(price / 100);
    var cents = price % 100;
    var moneyFormat = (Shopify || {}).money_format || '$ {{amount}}';

    return moneyFormat.replace(/\{\{amount\}\}/g, `${dollars}.${cents}`);
  }
});
